export const FETCH_UNLISTED_SITES_SUCCESS = 'fetchUnlistedSitesSuccess';
export const UPDATE_ACTIVE_SORT_FIELD_UNLISTED_SITES_M = 'updateActiveSortFieldUnlistedSitesMutation';
export const UPDATE_SEARCH_UNLISTED_SITES_M = 'updateSearchUnlistedSitesMutation';
export const CLEAR_SEARCH_UNLISTED_SITES_M = 'clearSearchUnlistedSitesMutation';
export const CHECK_UNLISTED_SITE_M = 'checkUnlistedSiteMutation';
